//#region src/assets/do-flag.svg
var do_flag_default = "" + new URL("do-flag-CBJRQ-JR.svg", import.meta.url).href;
//#endregion
export { do_flag_default as default };

//# sourceMappingURL=do-flag.js.map